import React from 'react';
import {Platform} from 'react-native';
import Settings from 'src/Settings';
import ConnectAndPayLogo from '../img/svg/ConnectAndPayLogo';
import Logo365Pay from '../img/svg/Logo365Pay';
import Styles from '../Styles';
import Localized from 'src/constants/AppStrings';
import PayWebLogo from 'src/components/img/svg/PayWebLogo';
import {BuildTypeEnum} from '../../constants/BuildTypeEnum';
import AramarkLogo from '../img/svg/AramarkLogo';

export default (props: {small?: boolean; width?: number; height?: number}) => {
  const size = props.small ? Styles.Fonts.f5 : Styles.Heights.h6 * 3;
  const width = props.width || size;
  const height = props.height || size;

  switch (Settings.buildType) {
    case BuildTypeEnum.aramark:
      return <AramarkLogo size={size} />;
    case BuildTypeEnum.canteen:
      return <ConnectAndPayLogo width={width} height={height} />;
    default:
      if (Platform.OS === 'web') {
        return <PayWebLogo width={size} height={size} />;
      } else {
        return (
          <Logo365Pay
            accessible={true}
            accessibilityRole={'image'}
            accessibilityLabel={Localized.Labels.logo_365Pay}
            aria-label={Localized.Labels.logo_365Pay}
            width={width}
            height={height}
          />
        );
      }
  }
};
